import {DecimalPipe} from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'formatNumber',
  standalone: true
})

export class PipeNumberFormat implements PipeTransform {
  private decimalPipe = inject(DecimalPipe);


  transform(value: number | string, digitsInfo: string = '1.2-2'): string | null {
    return this.decimalPipe.transform(value, digitsInfo);
  }
}
